import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IAllMetadataResponse } from '../models';
import { KeyValue, IMetadata } from '../models/metadata.model';

@Injectable()
export class MetadataLoadingService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  public getAllMetadata(lang: string = 'en'): Observable<IMetadata[]> {
    const url =
      environment.business.default.baseUrl + `/metadata/all?lang=${lang}`;
    return this.httpGet<IAllMetadataResponse>(url).pipe(
      map(data => this.mapMetadataResponse(data))
    );
  }

  public getSingleMetadata(
    key: string,
    lang: string = 'en'
  ): Observable<IMetadata> {
    const url =
      environment.business.default.baseUrl +
      `/metadata/key/${key}?lang=${lang}`;
    return this.httpGet<any>(url).pipe(
      map(data => {
        const metadataArrary = this.mapMetadataResponse(data);
        return metadataArrary.length > 0 ? metadataArrary[0] : null;
      })
    );
  }

  mapMetadataResponse(res: IAllMetadataResponse): IMetadata[] {
    const output: IMetadata[] = [];
    if (res && res.metadata && res.metadata.length > 0) {
      res.metadata.forEach(kv => {
        const metadata: IMetadata = { id: kv.uid, keyValues: []};
        if (
          kv.keyValues &&
          kv.keyValues.keyValue &&
          kv.keyValues.keyValue.length > 0
        ) {
          kv.keyValues.keyValue.forEach(keyValuePair => {
            metadata.keyValues.push({
              key: keyValuePair.key,
              value: keyValuePair.value,
              sortOrder: keyValuePair.sortOrder ? +keyValuePair.sortOrder : 0,
              parentKey: keyValuePair.parentKey,
            });
          });
        }
        output.push(this.sortKeyValuePair(metadata));
      });
    }
    return output;
  }

  /**
   * Sorts resources keyvalue pairs as funcational requirement- They want to sort the
   * resource list in such way that Organization and Users key should come 1st
   * @param metadata
   * @returns Metadata
   */
  sortKeyValuePair(metadata: IMetadata): IMetadata {
    const outputKVs: KeyValue[] = metadata.keyValues.sort(
      (n1, n2) => n1.sortOrder - n2.sortOrder
    );
    return { id: metadata.id, keyValues: outputKVs };
  }
}
